import styled from 'styled-components';

const ContentWrapper = styled.div`
  ${'' /* margin: 0 auto;
  @media (min-width: 768px) {
    width: 100%;
  } */}
  width: 100%;
`;

export default ContentWrapper;
